

















import Vue from 'vue';

export default Vue.extend({
  name: 'HubFileInput',

  inheritAttrs: false,

  props: {
    hidden: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    oneMb: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Array,
      default() {
        return [];
      },
    },
    value: {
      type: File,
      // default: new File([''], '', {
      //   type: 'text/plain',
      // }),
      default: undefined,
      required: false,
    },
  },

  data() {
    return {
      fileItem: this.value,
    };
  },

  watch: {
    fileItem() {
      this.$emit('input', this.fileItem);
    },
  },

  mounted() {
    if (this.oneMb) { // file must be < 1 Mb
      const verifySize = (value: File) => {
        const isIncorrect = value && value.size / 1024 / 1024 > 1;
        return isIncorrect
          ? this.$t('file_need_to_be_less_than_1MB')
          : undefined;
      };

      this.rules.push(verifySize);
    }
  },
});
